import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSortStyle0 = cosmosIconCss;

const CosmosIconSort$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSort extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '62916a227a3450f3d5372a9b509119d589f45ae4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fe9282780e4a6312b64cf09def9fe985cd6f1aff', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '06bf51ddbb6463abca85ca12d302ed63821dfa66', d: "M15.683 7.874h2.284a.4.4 0 0 0 .283-.683l-3.034-3.034a.4.4 0 0 0-.566 0l-3.034 3.034a.4.4 0 0 0 .283.683h2.284v9.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-9.5Zm-7.869 6.251h2.284a.4.4 0 0 1 .283.683l-3.034 3.034a.4.4 0 0 1-.566 0l-3.034-3.034a.4.4 0 0 1 .283-.683h2.284v-9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v9.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSortStyle0; }
}, [1, "cosmos-icon-sort", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sort"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sort":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSort$1);
            }
            break;
    } });
}

const CosmosIconSort = CosmosIconSort$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSort, defineCustomElement };
